import { extendedArea } from '@bpd-library/utilities';
import { getSubscriptionUser } from '@store/subscription/store';
import environment from '@utilities/environment';
import { GTMPush } from '@utilities/gtm';
import { sha256 } from '@utilities/sha-256';
import md5 from 'md5';

import { areaSubscriptionStore } from '../store';

const handleVirtualPageGTM = async (options: { step: number; areaOnly: boolean }) => {
    const { areaProject } = await extendedArea.getData(window.__ENVIRONMENT_DETAILS__.areaId);
    const userInfo = getSubscriptionUser();

    const logData = (data: any) =>
        environment.isLocal || environment.isTest
            ? console.log(`%c[GTM] - ${data.virtualTitle}`, 'color: lightblue; font-size: 20px')
            : null;

    switch (options.step) {
        case 0: {
            const data = {
                event: 'gtm.virtualPageview',
                virtualURL: `/${areaProject?.name!}/newsletter_subscription/projectfase`,
                virtualTitle: 'Newsletter Subscribe Project Phase',
            };
            GTMPush(data);
            logData(data);
            break;
        }
        case 1: {
            const data = {
                event: 'gtm.virtualPageview',
                virtualURL: `/${areaProject?.name}/newsletter_subscription/contact_info`,
                virtualTitle: 'Newsletter Subscribe Contact Info',
            };
            GTMPush(data);
            logData(data);
            break;
        }
        case 2: {
            if (!userInfo?.email) {
                console.error('[GTM]: ERROR - no user email provided');
                break;
            }
            if (options.areaOnly) {
                const data = {
                    event: 'gtm.virtualPageview',
                    virtualURL: `/${areaProject?.name}/newsletter_subscription/newsletter_complete`,
                    virtualTitle: 'Newsletter Subscribe Newsletter Complete',
                    subscriptionEmail: md5(userInfo.email), // SHA-256 hashed e-mail address put into the contact details (not logged in) or from profile (logged in)
                    email_sha_256: await sha256(userInfo.email),
                };
                GTMPush(data);
                logData(data);
            } else {
                const data = {
                    event: 'gtm.virtualPageview',
                    virtualURL: `/${areaProject.name}/newsletter_subscription/projectfase_complete`,
                    virtualTitle: 'Newsletter Subscribe Project Fase Complete',
                    subscriptionEmail: md5(userInfo.email),
                    email_sha_256: await sha256(userInfo.email),
                };
                GTMPush(data);
                logData(data);
            }
            break;
        }
        case 3: {
            if (!userInfo?.email) {
                console.error('[GTM]: ERROR - no user email provided');
                break;
            }
            const data = {
                event: 'gtm.virtualPageview',
                virtualURL: `/${areaProject.name}/newsletter_subscription/woningtype_complete`,
                virtualTitle: 'Newsletter Subscribe Woningtype Complete',
                subscriptionEmail: md5(userInfo.email),
                email_sha_256: await sha256(userInfo.email),
            };
            GTMPush(data);
            logData(data);
            break;
        }
    }
};

const handleSelectionGTM = async (options: { step: number; areaOnly: boolean }) => {
    const { selectedProjectPhases, selectedPropertyTypes } = areaSubscriptionStore.getState();
    const { areaProject, projectPhases, propertyTypes } = await extendedArea.getData(
        window.__ENVIRONMENT_DETAILS__.areaId,
    );

    const logData = (data: any) =>
        environment.isLocal || environment.isTest
            ? console.log(
                  `%c[GTM] - ${data.eventAction} ${data.eventLabel}`,
                  'color: lightgreen; font-size: 20px',
              )
            : null;

    switch (options.step) {
        case 0: {
            if (options.areaOnly) {
                const data = {
                    event: 'newsletterSubscription',
                    eventCategory: 'newsletter',
                    eventAction: 'subscribe gebied',
                    eventLabel: areaProject.name,
                };
                GTMPush(data);
                logData(data);
            } else {
                selectedProjectPhases.forEach((projectPhaseId) => {
                    const project = projectPhases.find(({ id }) => id === projectPhaseId);
                    const data = {
                        event: 'newsletterSubscription',
                        eventCategory: 'newsletter',
                        eventAction: 'subscribe fase',
                        eventLabel: `${projectPhaseId}_${project?.name}`,
                    };
                    GTMPush(data);
                    logData(data);
                });
            }
            break;
        }
        case 2: {
            selectedPropertyTypes.forEach((propertyTypeId) => {
                const property = propertyTypes.find(({ id }) => id === propertyTypeId);
                const data = {
                    event: 'newsletterSubscription',
                    eventCategory: 'newsletter',
                    eventAction: 'subscribe woningtype',
                    eventLabel: `${propertyTypeId}_${property?.name}`,
                };
                GTMPush(data);
                logData(data);
            });
            break;
        }
    }
};

export { handleVirtualPageGTM, handleSelectionGTM };
